import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, Phone, ArrowRight } from "lucide-react";
import { BRAND } from "../App";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Get a Quote", path: "/get-quote" },
    { label: "Cars for Sale", path: "/cars-for-sale" },
    { label: "About Us", path: "/about" },
    { label: "Contact", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? "bg-white shadow-md" : "bg-white/95 backdrop-blur-sm"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center">
          <img src={BRAND.logo} alt={BRAND.name} className="h-10 sm:h-14 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`font-semibold text-sm transition-colors relative ${isActive(item.path) ? "text-[#E31E24]" : "text-black/80 hover:text-black"}`}
            >
              {item.label}
              {isActive(item.path) && <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#E31E24]"></span>}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={BRAND.phoneHref} className="hidden xl:flex items-center gap-2 text-black/70 hover:text-black transition-colors">
            <Phone size={16} className="text-[#E31E24]" />
            <div className="text-left">
              <p className="text-[10px] uppercase tracking-wide text-black/50 leading-none">Call Shabi</p>
              <p className="text-sm font-bold leading-tight">{BRAND.phone}</p>
            </div>
          </a>
          <Link to="/get-quote" className="bg-[#E31E24] text-white font-bold px-4 lg:px-6 py-2.5 lg:py-3 hover:bg-[#C01A1F] transition-all flex items-center gap-2 text-sm">
            Request Transport
            <ArrowRight size={16} />
          </Link>
        </div>

        <button className="lg:hidden text-black" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="lg:hidden bg-white border-t border-black/10 overflow-hidden">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`py-3 px-4 font-semibold transition-colors ${isActive(item.path) ? "bg-[#E31E24] text-white" : "text-black/80 hover:bg-black/5"}`}
              >
                {item.label}
              </Link>
            ))}
            <a href={BRAND.phoneHref} className="py-3 px-4 font-semibold text-black/80 border-t border-black/10 mt-2 flex items-center gap-2">
              <Phone size={16} className="text-[#E31E24]" />
              {BRAND.phone}
            </a>
            <Link to="/get-quote" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#E31E24] text-white font-bold px-4 py-3 text-center mt-2">
              Request Transport
            </Link>
          </nav>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
